import React, { useState } from 'react';
import styled from 'styled-components';
import { logout, getAccessToken, getUserInitial } from '../services/apiService';
import LoginModal from './LoginModal';

const LoginContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const LoginButton = styled.button`
  background-color: ${props => props.theme.colors.primary || '#007bff'};
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${props => props.theme.colors.primaryDark || '#0056b3'};
  }

  &:active {
    opacity: 0.8;
  }
`;

const LogoutButton = styled(LoginButton)`
  background-color: ${props => props.theme.colors.danger || '#dc3545'};

  &:hover {
    background-color: ${props => props.theme.colors.dangerDark || '#c82333'};
  }
`;

const UserInitial = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.primary || '#007bff'};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
`;

const Login = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!getAccessToken());
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleOpenLoginModal = () => {
    setShowLoginModal(true);
  };

  const handleCloseLoginModal = () => {
    setShowLoginModal(false);
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = async () => {
    await logout();
    setIsLoggedIn(false);
    // Refresh the page to update all components with new auth state
    window.location.reload();
  };

  return (
    <LoginContainer>
      <LoginModal
        isOpen={showLoginModal}
        onClose={handleCloseLoginModal}
        onLoginSuccess={handleLoginSuccess}
      />
      {isLoggedIn ? (
        <>
          <UserInitial>{getUserInitial()}</UserInitial>
          <LogoutButton onClick={handleLogout}>
            Logout
          </LogoutButton>
        </>
      ) : (
        <LoginButton onClick={handleOpenLoginModal}>
          Login
        </LoginButton>
      )}
    </LoginContainer>
  );
};

export default Login;
